import {TransformProjectFormValidationSchema} from '@/features/projects/formSchemas'
import {ProjectExtended} from '@/features/projects/types'
import {getNextWorkingDay} from '@/features/projects/utils'
import {zodResolver} from '@hookform/resolvers/zod'
import dayjs from 'dayjs'
import {ReactNode} from 'react'
import {FormProvider, useForm} from 'react-hook-form'

export const TransformProjectFormProvider = ({
    children,
    project,
    holidays
}: {
    children: ReactNode
    project: ProjectExtended
    holidays: {date: string}[]
}) => {
    const startDate = getNextWorkingDay(dayjs(project.expirationDate).toDate(), holidays)
    const expirationDate =
        project.durationDays && startDate ? dayjs(startDate).add(project.durationDays, 'day').toDate() : undefined

    const form = useForm<TransformProjectFormValidationSchema>({
        mode: 'onBlur',
        resolver: zodResolver(TransformProjectFormValidationSchema),
        defaultValues: {
            id: project.id,
            patient: {
                id: project.patient?.id,
                fullName: project.patient?.fullName,
                serviceType: project.patient?.serviceType
            },
            referringProject: project,
            // extended and maintenance sectors are deprecated sectors, so we convert them to mixed
            sector: project.sector == 'extended' || project.sector == 'maintenance' ? 'mixed' : project.sector,
            assistiveRegime: project.assistiveRegime || undefined,
            startDate,
            expirationDate,
            durationDays: project.durationDays ? project.durationDays : undefined,
            sender: project.sender || undefined,
            specialist: project.specialist || undefined,
            siarProject: 'same_as_previous'
        }
    })

    return <FormProvider {...form}>{children}</FormProvider>
}
